import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockProps } from '../../defs/block';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { SharpenerBlockComponent } from './SharpenerBlockComponent';
import { SharpenerBlockProps } from './SharpenerBlock';

const SharpenerBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  SharpenerBlockComponent,
);
export type SharpenerBlockEntity = EntityType<typeof SharpenerBlockEntityDef>;

export function _spawnSharpenerBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: BlockProps,
  position: Vector2,
): SharpenerBlockEntity {
  // spawn base block
  const entity = _spawnBaseBlockEntity(
    SharpenerBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockSharpener: {
        props: props as SharpenerBlockProps,
        option: def.option,
      },
    },
  );

  // build scene
  entity.c.view2d.view.addChild(entity.c.blockSharpener.view);

  return entity;
}
